import { render, staticRenderFns } from "./PoliciesPage.vue?vue&type=template&id=fce5f0aa&scoped=true&"
import script from "./PoliciesPage.vue?vue&type=script&lang=js&"
export * from "./PoliciesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce5f0aa",
  null
  
)

export default component.exports